
import ApiService from '@/core/services/ApiService';
import { defineComponent, ref } from 'vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useBus } from '../../../../bus';
import { Field } from 'vee-validate';
import { DrawerComponent } from '@/assets/ts/components/_DrawerComponent';
import { VueCookieNext } from 'vue-cookie-next';

export default defineComponent({
  name: 'kt-drawer-trainningPartner-institute',
  components: { Field },

  data() {
    return {
      load: false,
      institute_info_id: '',
      entity_id: '',
      tranche_id: '',
      association: [],
      tranche: [] as any,
      loading: false,
    };
  },
  async created() {
    await this.associationList();
    await this.getTranche();
    this.emitter.on('entity-add-trainningPartner-data', async (id) => {
      this.institute_info_id = id;
      // api
    });
  },
  methods: {
    async getTranche() {
      await ApiService.get('configurations/tranche/list')
        .then((response) => {
          this.tranche = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async associationList() {
      await ApiService.get('entity/list')
        .then((response) => {
          this.association = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async formSubmit() {
      let user_id = VueCookieNext.getCookie('_seip_user');
      let data = {
        entity_id: this.entity_id,
        tranche_id: this.tranche_id,
        institute_id: this.institute_info_id,
        user_id: user_id.id
      };

      this.loading = true;
      await ApiService.post('institute/detail/map_entity_institute', data)
        .then((response) => {
          DrawerComponent?.hideAll();
          this.loading = false;
          if (response.status == 200) {
            this.emitter.emit('trainning-updated', true);
            // if(response.status="error")
            Swal.fire({
              title: 'Success!',
              text: response.data.data,
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(() => {
              this.entity_id = '';
              this.tranche_id = '';
              this.institute_info_id = '';
            });
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
          console.log(response);
        });
    },
  },
});
